import { render, staticRenderFns } from "./AppChartsRightSide.vue?vue&type=template&id=0455c1c3&scoped=true&"
import script from "./AppChartsRightSide.vue?vue&type=script&lang=js&"
export * from "./AppChartsRightSide.vue?vue&type=script&lang=js&"
import style0 from "./AppChartsRightSide.vue?vue&type=style&index=0&id=0455c1c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455c1c3",
  null
  
)

export default component.exports